'use client';

import React from 'react';
import { ExperienceType } from '../types';
import Notices from '@/components/packages/Notices';
import Border from '../../common/border';

interface ExperienceNoticesProps {
  experience: unknown;
  type: ExperienceType;
}

export const ExperienceNotices: React.FC<ExperienceNoticesProps> = ({
  experience,
}) => {
  if (!experience) return null;

  const exp = experience as {
    notices?: Array<{
      title?: string;
      description?: string;
      imageUrl?: string;
      icon?: string;
      _id?: string;
      createdAt?: string;
      updatedAt?: string;
    }>;
    guidelines?: {
      notices?: Array<{
        title?: string;
        description?: string;
        imageUrl?: string;
        icon?: string;
        _id?: string;
        createdAt?: string;
        updatedAt?: string;
      }>;
    };
  };

  const notices = exp?.notices || exp?.guidelines?.notices || [];

  if (!Array.isArray(notices) || notices.length === 0) {
    return null;
  }

  // Filter and map notices to ensure required fields are present
  const validNotices = notices
    .filter(notice => notice.title && notice.description)
    .map(notice => ({
      title: notice.title!,
      description: notice.description!,
      imageUrl: notice.imageUrl,
      icon: notice.icon,
      _id: notice._id,
      createdAt: notice.createdAt,
      updatedAt: notice.updatedAt,
    }));

  if (validNotices.length === 0) {
    return null;
  }

  return (
    <div className='space-y-4'>
      <Notices options={validNotices} title='Notices' />
      <div className='pt-4'>
        <Border />
      </div>
    </div>
  );
};
